import { faFileImage, faFileVideo, faFileZipper } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import { ICreativeFileType } from "media/model"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface IMediaTypeProps {
  type: ICreativeFileType
}

export const MediaType = React.memo(({ type }: IMediaTypeProps) => (
  <FlexBox
    sx={{
      "gap": ".3rem",
      "& .icon": {
        color: theme => (type === "archive" ? theme.palette.text.secondary : type === "image" ? "#54b4e2" : "#5abd51"),
        width: "1rem !important",
        height: "1rem !important"
      }
    }}>
    <FontAwesomeIcon
      icon={type === "archive" ? faFileZipper : type === "image" ? faFileImage : faFileVideo}
      className="icon"
    />
    <Typography fontSize=".8rem">{translate(`campaign.creative.row.type.${type}`)}</Typography>
  </FlexBox>
))
